// const host = window.location.host; ReferenceError: window is not defined;

export const host = typeof window !== 'undefined' ? window.location.host : '';

export const imageUrl = `https://${host}`;
export const thumbUrl = `https://${host}`;
export const pdfUrl = `https://${host}`;
export const url = '/backend';
